var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7462 8.59711L18.5719 0.833374H16.9546L11.0252 7.57311L6.29276 0.833374H0.833252L7.99116 11.026L0.833252 19.1667H2.45052L8.70833 12.0477L13.7071 19.1667H19.1666L11.7462 8.59711ZM9.53035 11.1154L8.804 10.0998L3.03374 2.02638H5.51819L10.1763 8.54434L10.8996 9.55993L16.9538 18.0318H14.4694L9.53035 11.1154Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7edaa80cfcaef723eeef7c9cde270c21.svg";
export { ForwardRef as ReactComponent };